
import { of as observableOf,  Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IEventTextTemplate, IUpdateEventTextTemplate } from './eventcustomfields-model';
import { TextTemplateType } from '@shared/enums/TextTemplateType';

@Injectable()
export class EventTextTemplatesService {

  constructor(private http: HttpClient) { }

  private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
  private static readonly ENDPOINT = 'events/{eventId}/eventtexttemplates';

  public getEventTextTemplate(eventId: string, textTemplateType: TextTemplateType): Observable<SuccessResponse<IEventTextTemplate> | ErrorResponse> {
    return this.http
    .get<SuccessResponse<IEventTextTemplate>>(EventTextTemplatesService.URL + EventTextTemplatesService.ENDPOINT.replace('{eventId}', eventId) + '/' + textTemplateType).pipe(
    catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

  public updateEventTextTemplate(data: IUpdateEventTextTemplate): Observable<SuccessResponse<boolean> | ErrorResponse> {
    return this.http
    .put<SuccessResponse<boolean>>(EventTextTemplatesService.URL + EventTextTemplatesService.ENDPOINT.replace('{eventId}', data.eventId) + '/' + data.textTemplateType, data).pipe(
      catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

}
